import { render } from "./CookiesSection.vue?vue&type=template&id=ee3a3050"
import script from "./CookiesSection.vue?vue&type=script&lang=js"
export * from "./CookiesSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__